import React, { useEffect, useState } from "react";
import {
  ActionIcon,
  Button,
  Group,
  Modal,
  Radio,
  TextInput,
} from "@mantine/core";

import useStyles from "./style";
import CloseCircle from "../CloseCircle";
import { MdFormatColorFill } from "react-icons/md";
import { useDisclosure } from "@mantine/hooks";
import { updateFillMedication } from "../../services";
import { useSelector } from "react-redux";
import swal from "sweetalert";

const FillMedicationModal = ({ data, clientId }) => {
  const { classes } = useStyles();
  const [opened, { open, close }] = useDisclosure(false);
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(null);
  const [newCcount, setNewCount] = useState(null);
  const [countPreference, setCountPreference] = useState("increase");
  const { profile } = useSelector((state) => state?.profile);
  const [total, setTotal] = useState(null);

  useEffect(() => {
    if (newCcount) {
      if (countPreference === "increase") {
        setCount(Number(data?.medicineRemaining) + newCcount);
        setTotal(Number(data?.totalMedicine) + newCcount);
      } else {
        setCount(Number(data?.medicineRemaining) - newCcount);
        setTotal(Number(data?.totalMedicine) - newCcount);
      }
    }
  }, [countPreference]);

  const handleOpen = () => {
    open();
    data?.medicineRemaining && setCount(Number(data?.medicineRemaining));
    data?.totalMedicine && setTotal(Number(data?.totalMedicine));
  };

  const handleClose = () => {
    close();
    setCount(null);
  };

  const handleUpdate = async () => {
    if (count <= 0) {
      await swal({
        title: `Warning`,
        text: "Current medication count can not be less than or equal to zero.",
        icon: "warning",
        dangerMode: true,
        buttons: true,
      });
    } else {
      setLoading(true);
      const payload = {
        medicationId: data?.id,
        medicationName: data?.medicationName,
        clientId,
        count:
          countPreference == "decrease"
            ? Number(-newCcount)
            : Number(newCcount),
      };
      if (newCcount) {
        const resp = await updateFillMedication(payload);
        if (resp) {
          handleClose();
        }
      }
      setLoading(false);
    }
  };

  return (
    <>
      <ActionIcon
        color=""
        id="fill"
        title="Fill"
        variant="light"
        onClick={handleOpen}
        // disabled={profile?.user?.type == "staff" ? true : false}
      >
        <MdFormatColorFill size={20} />
      </ActionIcon>
      <Modal
        centered
        size={"lg"}
        shadow="md"
        radius={"lg"}
        zIndex={1000}
        opened={opened}
        onClose={handleClose}
        overlayProps={{ blur: 3 }}
        className={classes.fillMedicationModal}
      >
        <CloseCircle onclose={handleClose} />
        <div className={classes.wrapper}>
          <h2>Update Medication Count</h2>

          <div className={classes.formRow}>
            <Radio.Group
              name="Refill Order"
              label="Do You want to increase or decrease current count?"
              value={countPreference}
              onChange={(event) => setCountPreference(event)}
              required
              withAsterisk
              color="yellow"
            >
              <Group mt="xs">
                <Radio value="increase" label="Increase" />
                <Radio
                  value="decrease"
                  label="Decrease"
                  disabled={count ? false : true}
                />
              </Group>
            </Radio.Group>
          </div>

          <div className={classes.formRow}>
            <div className={classes.textInputBox}>
              <TextInput
                size="sm"
                disabled
                type="number"
                // value={count}
                value={Number(count).toFixed(1)}
                label={"Current Medication Count"}
                // placeholder={"Enter Current Count"}
                // onChange={(e) => setCount(e.target.value)}
              />
            </div>

            {/* <div className={classes.textInputBox}>
              <TextInput
                label={"Total Medication"}
                size="sm"
                // placeholder={"Enter Current Count"}
                type="number"
                disabled
                value={total}
                // onChange={(e) => setCount(e.target.value)}
              />
            </div> */}
          </div>

          {/* <div className={classes.textInputBox}>
            <TextInput
              label={"Total Medication"}
              size="sm"
              type="number"
              disabled
              value={total}
            />
          </div> */}

          {/* </div> */}

          <div className={classes.textInputBox}>
            <TextInput
              size="sm"
              type="number"
              id="refill-count"
              value={newCcount}
              label={"Increase Medication Count"}
              placeholder={"Enter Refill Count"}
              min={0}
              step="0.1"
              onKeyDown={(e) => {
                if (e.key === "." && e.target.value.includes(".")) {
                  e.preventDefault();
                } else if (
                  !/[0-9]/.test(e.key) &&
                  e.key !== "Backspace" &&
                  e.key !== "Delete" &&
                  e.key !== "."
                ) {
                  e.preventDefault();
                }
              }}
              onChange={(e) => {
                let valueStr = e.target.value;
                if (valueStr?.includes(".")) {
                  const [integerPart, decimalPart] = valueStr?.split(".");
                  if (decimalPart.length > 1) {
                    valueStr = `${integerPart}.${decimalPart?.slice(0, 1)}`;
                  }
                }
                const value = Number(valueStr);

                if (value) {
                  if (countPreference === "increase") {
                    setNewCount(value);
                    setCount(Number(data?.medicineRemaining) + value);
                    setTotal(Number(data?.totalMedicine) + value);
                  } else {
                    setNewCount(value);
                    setCount(Number(data?.medicineRemaining) - value);
                    setTotal(Number(data?.totalMedicine) - value);
                  }
                } else {
                  setCount(Number(data?.medicineRemaining));
                  setTotal(Number(data?.totalMedicine));
                  setNewCount(null);
                }
              }}
            />
          </div>

          <Button
            loading={loading}
            id="update-refill"
            onClick={handleUpdate}
            className={classes.saveButton}
            disabled={Number(data?.medicineRemaining) === Number(count)}
          >
            Update
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default FillMedicationModal;
